<script>
export default {
  data() {
    return {
      trade_no: "",
      refund_no: "",
    };
  },
  methods: {
    async getRefundId(medCardNo, tradeno, totalmoney, clientName, invoiceNo) {
      try {
        this.$showLoad();
        let reno_Data = await this.$axios.get(
          `/register/getOutRefunTrade_no?medCardNo=${medCardNo}`
        );
        if (reno_Data.status === 200) this.refund_no = reno_Data.data;
        this.$hideLoad();
        if (this.refund_no !== "" && invoiceNo !== "" && clientName !== "") {
          this.reFundCommit(
            medCardNo,
            tradeno,
            this.refund_no,
            totalmoney,
            clientName,
            invoiceNo
          );
        } else {
          this.reFund(medCardNo, tradeno, this.refund_no, totalmoney, "", "");
        }
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("获取退费交易编号失败，请重试");
      }
    },

    //微信退费
    async reFund(
      medCardNo,
      tradeno,
      refundno,
      totalmoney,
      clientName,
      invoiceNo
    ) {
      this.$hideLoad();
      try {
        this.$showLoad();
        let requestData = {
          out_trade_no: tradeno,
          out_refund_no: refundno,
          refund_fee: parseInt((totalmoney - 0) * 100),
        };
        let refund_data = await this.$axios({
          method: "post",
          url: "/pay/refund",
          data: requestData,
        });
        if (refund_data.data.RspStatus === false) {
          this.$hideLoad();
          this.$toast.fail("退费失败,请到柜台退费");
        }
        this.$hideLoad();
      } catch (error) {
        console.log(error);
      }
    },

    //his退费确认
    async reFundCommit(
      medCardNo,
      tradeno,
      refundno,
      totalmoney,
      clientName,
      invoiceNo
    ) {
      try {
        let refund_data = {
          outTrade_no: tradeno,
          outRefund_no: refundno,
          totalFee: totalmoney,
          refundFee: totalmoney,
          medCardNo: medCardNo,
          clientName: clientName,
          hisTradeNo: invoiceNo,
        };
        let commitData = this.$axios.post({
          method: "post",
          url: "/register/registercommit",
          data: requestData,
        });
      } catch (error) {
        console.log(error);
        this.$hideLoad();
        this.$toast.fail("退费失败,请到柜台退费");
      }
    },
  },
};
</script>